import styled from "styled-components";

export const Img = styled.img`
  max-width: 100%;
`;